import * as React from 'react';
import { IconMapHighway16 } from '@cian/ui-kit-design-tokens/icons';

import { ITransportPoint } from '../../../../../../types/newbuildingsCompare';
import { getTransportPointColorStyle, metroIconMapper } from './transportIcons';

/**
 * Общая часть транспортной точки для десктопной (transportPointExtended) и мобильной
 * (transportPoint) строк — у обеих типов эти поля совпадают.
 */
export type TTransportPointIconData = Pick<ITransportPoint, 'type' | 'color' | 'undergroundType'>;

export interface ITransportPointIconProps {
  point: TTransportPointIconData;
  /** Класс бокса иконки: на десктопе и мобиле у него разные размеры. */
  className: string;
}

/**
 * Иконка транспортной точки: метро выбранного города, покрашенное в цвет линии, либо шоссе.
 * Один компонент на десктоп и мобилу, чтобы выбор иконки не разъезжался между экранами.
 */
export const TransportPointIcon = ({ point, className }: ITransportPointIconProps): React.JSX.Element => {
  const iconStyle = React.useMemo(() => getTransportPointColorStyle(point.color), [point.color]);

  return (
    <div className={className} style={iconStyle}>
      {point.type === 'underground' ? metroIconMapper(point.undergroundType) : <IconMapHighway16 />}
    </div>
  );
};
